var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"mytrip-logo",attrs:{"src":require("../../../public/images/icons/mytrip.svg"),"alt":"My Trip logo"}}),_c('p',{staticClass:"no-trips"},[_vm._v("You don’t have any items"),_c('br'),_vm._v(" in your trip. Use the heart icon"),_c('br'),_vm._v(" to add items to this trip.\n  ")])])
}]

export { render, staticRenderFns }